/* eslint-disable react/prop-types */
import React from 'react';
import { Modal } from 'antd';
import FormConfigs from 'components/Molecules/Forms/WithFieldConfigs/container/index';
import Input from '../../Fields/Input';
import { generateFieldPosition, generateFields } from '../../helper';
import Derived from '../../Fields/Derived';
import Checkbox from '../../Fields/Checkbox';
import { FIELD_POSITIONS, initValue } from './constants';
import { Middlewares } from '../../middlewares/index';
import classes from './Section.module.scss';
import { ListWorkmanship } from './components/list-workman/index';

export const Workmanship = ({ fields, configs, open, onCancel, sectionLabel }) => {
  const generatedFields = generateFields([...fields], configs);

  const initialValues = React.useMemo(() => {
    return {
      sectionName: sectionLabel,
      ...initValue(fields, configs),
    };
  }, [generatedFields, sectionLabel]);

  return (
    <Modal title="Workmanship" open={open} width={1300} onCancel={onCancel}>
      <FormConfigs
        className={classes.form}
        disabled
        layout="vertical"
        initialValues={initialValues}
        FIELD_PROVIDER={{
          INPUT: Input,
          DERIVED: Derived,
          CHECKBOX: Checkbox,
          DEFECTS: ListWorkmanship,
        }}
        fields={generateFieldPosition(
          [{ type: 'INPUT', name: 'sectionName', label: 'Section Name' }, ...generatedFields],
          FIELD_POSITIONS
        )}
        middlewares={Middlewares}
        renderMiddlewares={[
          (field, meta) => {
            const { FIELD_PROVIDER } = meta;
            const Element = FIELD_PROVIDER[field.type];
            if (!Element) return null;
            return <Element />;
          },
        ]}
      />
    </Modal>
  );
};
